(function (ng) {
  //component definition for the "Initiate a Return" page
  //creates and manages the order lookup to start the return
  //also saves the request state to create the return
  ng.module("evo.returns.initiate.components").component("initiateReturnPage", {
    templateUrl: [
      "TEMPLATES_BASE",
      function (TEMPLATES_BASE) {
        return (
          TEMPLATES_BASE + "returns/initiate/components/initiateReturnPage"
        );
      },
    ],
    bindings: {
      createRequest: "<",
      findOrderModel: "<",
    },
    controller: [
      "$state",
      "ordersService",
      function ($state, ordersService) {
        var ctrl = this;
        ng.extend(ctrl, {
          displayInitiateReturnForm: false,
          loading: false,
          orderHasNoItems: false,
          orderNotFound: false,
          orderNotReturnable: false,
          requestError: false,
          createRequest: {
            Comments: "",
            EmailAddress: "",
            Items: [],
            LabelType: null,
            OrderId: "",
          },
          findOrderModel: {
            EmailAddress: "",
            OrderId: "",
          },
        });

        //lookup the order from the service
        //and display the initiate return form
        ctrl.findOrder = function () {
          ctrl.displayInitiateReturnForm = false;
          ctrl.orderHasNoItems = false;
          ctrl.orderNotFound = false;
          ctrl.orderNotReturnable = false;
          ctrl.loading = true;
          ng.extend(ctrl.createRequest, {
            Comments: "",
            EmailAddress: "",
            Items: [],
            LabelType: null,
            OrderId: "",
          });

          ordersService
            .findOrder(
              ctrl.findOrderModel.OrderId,
              ctrl.findOrderModel.EmailAddress
            )
            .then(
              function (order) {
                ctrl.loading = false;

                if (!order) {
                  ctrl.orderNotFound = true;
                  return;
                } else if (!order.Items.length) {
                  ctrl.orderHasNoItems = true;
                  return;
                } else if (!order.CanReturn) {
                  ctrl.orderNotReturnable = true;
                  return;
                }

                ctrl.displayInitiateReturnForm = true;
                ctrl.orderNotFound = false;
                ng.extend(ctrl.createRequest, {
                  Comments: "",
                  EmailAddress: ctrl.findOrderModel.EmailAddress,
                  Items: order.Items,
                  LabelType: null,
                  OrderId: ctrl.findOrderModel.OrderId,
                });
              },
              function () {
                ctrl.requestError = true;
                ctrl.loading = false;
                return;
              }
            );
        };

        //save the draft of the RA and send the user to the confirm page
        ctrl.saveDraftAndConfirm = function (returnAuthorization) {
          $state.go("initiate.confirmRequestPage");
        };

        ctrl.$onInit = function () {
          //compare the initial state with what is bound to see if we need to overwrite
          //(in case the user hit the back button or something)
          if (ctrl.createRequest.OrderId) {
            ctrl.displayInitiateReturnForm = true;
          }
          //otherwise load the query string and authenticated state for the user
          //if both are provided, attempt to find the order immediately
          else if (
            ctrl.findOrderModel.EmailAddress &&
            ctrl.findOrderModel.OrderId
          ) {
            ctrl.findOrder();
          }

          dataLayerManager.pushEvoPageType("post purchase (initiate return)");
        };
      },
    ],
  });
})(angular);
